import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import useHandleErrors from '../../utils/user.utils';
import { useUser } from '../../utils/userContext';
import Select from 'react-select';
import * as XLSX from 'xlsx';



export default function AssignAssestlist() {
    const [assetSerialNumber, setAssetSerialNumber] = useState("");
    const [assignDate, setAssignDate] = useState("");
    const [assignedAssets, setAssignedAssets] = useState([]);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedAssetID, setSelectedAssetID] = useState('');
    const [assetList, setAssetList] = useState([]);
    const [empId, setEmpId] = useState('');
    const [employeeData, setEmployeeData] = useState({});
    const [loading, setLoading] = useState(false);
    const handleErrors = useHandleErrors();
    const { user } = useUser();
    const [employees, setEmployees] = useState([]);
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);
    const EmpName = employeeData?.FirstName + " " + employeeData?.MiddleName + " " + employeeData?.LastName;

    const EmpEmail = employeeData?.OfficialEmail
    const ClearIndicator = () => null;
    const [assetType, setAssetType] = useState("");
    const handleAssetTypeChange = (selectedOption) => {
        setAssetType(selectedOption ? selectedOption.value : '');
    };

    const assetTypeOptions = [
        { value: 'In Courier', label: 'In Courier' },
        { value: 'In Person', label: 'In Person' },
        { value: 'Online', label: 'Online' },
        { value: 'Offline', label: 'Offline' },
        { value: 'Electronic', label: 'Electronic' },
        { value: 'Others', label: 'Others' },
    ];

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchEmployees();
            getAssetReport()
            hasFetchedRef.current = true;
        }
    }, []);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            });
            if (response.status === 200) {
                console.log("API Response: ", response.data);
                const employeeOptions = response.data.onboardEmployeeDetails.map(emp => ({
                    value: emp.EmployeeId,
                    label: emp.EmployeeId
                }));
                setEmployees(employeeOptions);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleSelectChange = async (selectedOption) => {
        setEmpId(selectedOption.value);
        await fetchEmployeeData(selectedOption.value);
    };

    const handleAssign = () => {
        if (!selectedCategory || !selectedAssetID || !assetSerialNumber || !assignDate || !assetType) {
            toast.info("Please fill in all required fields.", {
                position: toast.POSITION.TOP_CENTER,
            });
            return
        }
        const newAsset = {
            assetCategory: selectedCategory,
            assetID: selectedAssetID,
            assetSerialNumber,
            assignDate,
            assetType,
        };
        setAssignedAssets([...assignedAssets, newAsset]);
        // Reset fields if needed
        setSelectedCategory('');
        setSelectedAssetID('');
        setAssetSerialNumber('');
        setAssignDate('');
        setAssetType("")
    };

    const handleDelete = (index) => {
        setAssignedAssets(assignedAssets.filter((_, i) => i !== index));
    };

    const getAssetReport = async () => {
        try {
            const path = "/getAssetReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                const responseData = response.data.AssignAssets || [];
                setData(responseData);
                setFilteredData(responseData);

                const assetLists = response?.data?.RegisterAssets?.filter((asset) => asset?.Status.toLowerCase() === "active");
                setAssetList(assetLists);
            }
            else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    // Handle 404 status code separately
                    setAssetList([]);
                    setData([]);
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    const fetchEmployeeData = async (id) => {
        if (id) {
            setLoading(true);
            try {
                const path = `/getOnboardEmployeeDetails?EmployeeId=${id}`;
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status) {
                    setEmployeeData(response.data);
                }
                else {
                    handleErrors(response);
                }
            } catch (error) {
                if (error.response) {
                    handleErrors(error.response);
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleCategoryChange = (e) => {
        const category = e.target.value;
        setSelectedCategory(category);
        setSelectedAssetID('');
        setAssetSerialNumber('');
    };

    const handleAssetIDChange = (e) => {
        const assetID = e.target.value;
        setSelectedAssetID(assetID);
        const asset = assetList.find(asset => asset.AssetId === assetID);
        setAssetSerialNumber(asset?.SerialNumber || '');
    };


    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        if (!empId) {
            toast.error("empId is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        if (assignedAssets.length === 0) {
            toast.error("Please fill in all required fields", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }
        const payload = {
            EmployeeId: empId,
            EmployeeName: EmpName,
            EmployeeOfficialEmail: EmpEmail,
            NoOfAssets: `${assignedAssets.length}`,
            UpdatedBy: user?.FirstName,
            Status: "Assigned",
            ActiveFlag: "Y",
            AssetStatus: "Insert",
            AssetList: assignedAssets?.map(asset => ({
                AssetId: capitalizeWords(asset.assetID, true),
                CategoryType: capitalizeWords(asset.assetCategory),
                AssignDate: asset.assignDate,
                SerialNumber: asset.assetSerialNumber,
                AssignmentType: asset.assetType
            }))
        };
        try {
            const path = "/assignAsset";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                toast.success("Assets assigned successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                  // Reset fields after successful submission
            setEmpId(null);
            setEmployeeData(null);
            setSelectedCategory(''); 
            setSelectedAssetID(''); 
            setAssetSerialNumber(''); 
            setAssignDate(''); 
            setAssetType(''); 
            setAssignedAssets([]); 
            // Fetch the updated asset report after resetting the form
            getAssetReport();
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        }
        finally {
            setLoading(false);
        }
    };

    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Assigned Asset List');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            link.download = 'AssignedAssetReport.xlsx';

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Assigned Asset List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const shareData = {
        title: 'Assigned Asset List',
        text: 'Check out the Assigned Asset list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Assigned Asset");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, 'AssignedAssetReport.xlsx');
    };

    const categoryOptions = [
        ...[...new Set(assetList?.map(asset => asset.CategoryType.toLowerCase()))]
            .map(category => ({
                value: category,
                label: assetList.find(asset => asset.CategoryType.toLowerCase() === category)?.CategoryType || category
            }))
    ];

    const assetOptions = [
        ...[...new Set(assetList
            ?.filter(asset => asset.CategoryType.toLowerCase() === selectedCategory.toLowerCase())
            .map(asset => asset.AssetId.toLowerCase())
        )]
            .map(assetId => ({
                value: assetId,
                label: assetList.find(asset => asset.AssetId.toLowerCase() === assetId)?.AssetId || assetId
            }))
    ];

    const capitalizeWords = (str, isId = false) => {
        if (!str) return ''; // Handle null or undefined values safely
        return isId ? str.toUpperCase() : 
            str.split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' ');
    };


    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Assign</h3>
                        </div>
                        <div class="col-auto">
                            <Link to={'/AssetMasterReport'} class="btn btn-primary mt-lg-0 mt-4"><i class="ri-list-indefinite"></i> View All Assets</Link>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body" id="assignAssetDetails">
                                    <h5 className="title accordion-title" data-toggle="collapse" data-target="#assignAsset">Assign Asset</h5>
                                    <div className="collapse show" id="assignAsset" data-parent="#assignAssetDetails">
                                        <div className="row">
                                            <div className="form-group col-md-4">
                                                <label htmlFor="aaempid" className="required">Employee ID</label>
                                                <Select
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    options={employees}
                                                    onChange={handleSelectChange}
                                                    placeholder="Select Employee ID"
                                                    value={empId ? { value: empId, label: empId } : null}
                                                    components={{ ClearIndicator }}
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                        control: base => ({ ...base, zIndex: 1 })
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label htmlFor="assdate">Employee Name</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    readOnly
                                                    value={empId && employeeData ? `${employeeData.FirstName} ${employeeData.LastName}` : ""}
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label htmlFor="aaoemail">Official Email</label>
                                                <input
                                                    type="email"
                                                    readOnly
                                                    className="form-control"
                                                    value={empId && employeeData ? employeeData.OfficialEmail : ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="table-responsive asset-information">
                                                    <table className="table grid">
                                                        <thead className="bg-light">
                                                            <tr>
                                                                <th width="20%">Category</th>
                                                                <th width="20%">ID</th>
                                                                <th width="20%">Serial Number</th>
                                                                <th width="20%">Assign Date</th>
                                                                <th width="20%">Assign Type</th>
                                                                <th />
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <Select
                                                                        className="react-select-container"
                                                                        classNamePrefix="react-select"
                                                                        value={categoryOptions.find(option => option.value === selectedCategory) || null}
                                                                        onChange={(selectedOption) => {
                                                                            const category = selectedOption?.value || '';
                                                                            setSelectedCategory(category);
                                                                            setSelectedAssetID('');
                                                                            setAssetSerialNumber('');
                                                                        }}
                                                                        options={categoryOptions}
                                                                        placeholder="Select Category"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                        }}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Select
                                                                        className="react-select-container"
                                                                        classNamePrefix="react-select"
                                                                        value={assetOptions.find(option => option.value === selectedAssetID) || null}
                                                                        onChange={(selectedOption) => {
                                                                            const assetID = selectedOption?.value || '';
                                                                            setSelectedAssetID(assetID);
                                                                            const asset = assetList.find(asset => asset.AssetId.toLowerCase() === assetID.toLowerCase());
                                                                            setAssetSerialNumber(asset?.SerialNumber || '');
                                                                        }}
                                                                        options={assetOptions}
                                                                        isDisabled={!selectedCategory}
                                                                        placeholder="Select"
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                        }}
                                                                    />


                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        readOnly
                                                                        value={assetSerialNumber}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        value={assignDate}
                                                                        onChange={(e) =>
                                                                            setAssignDate(e.target.value)
                                                                        }
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Select
                                                                        className="react-select-container"
                                                                        classNamePrefix="react-select"
                                                                        name="assetType"
                                                                        value={assetTypeOptions.find(option => option.value === assetType) || null}
                                                                        onChange={handleAssetTypeChange}
                                                                        options={assetTypeOptions}
                                                                        components={{ ClearIndicator }}
                                                                        isClearable
                                                                        menuPortalTarget={document.body}
                                                                        styles={{
                                                                            menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                            control: base => ({ ...base, zIndex: 1 })
                                                                        }}
                                                                    />

                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        className="btn btn-secondary btn-action"
                                                                        type="button"
                                                                        title="Assign"
                                                                        onClick={handleAssign}
                                                                    >
                                                                        <i className="ri-checkbox-circle-line"></i>{" "}
                                                                        Assign
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <small className="form-text text-muted text-center mt-0">
                                                        <i className="ri-information-2-line"></i> Multiple assets can be assigned
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col">
                                            <h5 className="title mt-1 mb-0">Asset Summary</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button
                                                type="button"
                                                title="Email"
                                                rel="tooltip"
                                                className="btn btn-light btn-circle ml-2"
                                                onClick={() => sendEmail('')}
                                            >
                                                <i className="ri-mail-send-fill"></i>
                                            </button>
                                            <button
                                                type="button"
                                                title="Share"
                                                rel="tooltip"
                                                className="btn btn-light btn-circle ml-2"
                                                onClick={handleShare}
                                            >
                                                <i className="ri-share-fill"></i>
                                            </button>
                                            <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                <i className="ri-export-fill"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            <div className="table-responsive asset-information">
                                                <table className="table grid">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th width="30">S.No.</th>
                                                            <th>Category</th>
                                                            <th>ID</th>
                                                            <th>Serial Number</th>
                                                            <th>Assign Date</th>
                                                            <th width="40">Assign Type</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {assignedAssets?.map((asset, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    {String(index + 1).padStart(2, "0")}
                                                                </td>
                                                                <td>{capitalizeWords(asset.assetCategory)}</td>
                                                                <td>{capitalizeWords(asset.assetID, true)}</td>
                                                                <td>{asset.assetSerialNumber}</td>
                                                                <td>{asset.assignDate}</td>
                                                                <td>{asset.assetType}</td>
                                                                <td className="text-center">
                                                                    <button
                                                                        className="btn btn-link text-danger btn-action"
                                                                        type="button"
                                                                        title="Delete"
                                                                        onClick={() => handleDelete(index)}
                                                                    >
                                                                        <i className="ri-delete-bin-6-line"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center">
                    <button class="btn btn-light" type="reset">Cancel</button>
                    <button class="btn btn-primary" type="button" onClick={handleSubmit}>Submit <i class="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
        </div>
    )
}
